/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular
    .module('vcutils.zipcode', [
      'restmod',
      'ui.router',
      'ui.bootstrap'
    ]);
}());
